// prop-types is a library for typechecking of props
import PropTypes from 'prop-types';

// @mui material components
import Card from '@mui/material/Card';

// Material Kit 2 React components
import MKBox from 'components/MKBox';
import MKTypography from 'components/MKTypography';

function CenteredBlogCard({ color, image, title, description, action }) {
  return (
    <Card sx={{ bgcolor: 'warning.main' }}>
      <MKBox position='relative' borderRadius='lg' mx={2} mt={-3}>
        <MKBox
          component='img'
          src={image}
          alt={title}
          borderRadius='lg'
          width='100%'
          position='relative'
          zIndex={1}
        />
        <MKBox
          borderRadius='lg'
          shadow='md'
          width='100%'
          height='100%'
          position='absolute'
          left={0}
          top={0}
          sx={{
            backgroundImage: `url(${image})`,
            transform: 'scale(0.94)',
            filter: 'blur(12px)',
            backgroundSize: 'cover',
          }}
        />
      </MKBox>
      <MKBox p={3} mt={-1} textAlign='center'>
        <MKTypography
          textGradient
          color={color}
          display='inline'
          variant='h2'
          my={1}
        >
          {title}
        </MKTypography>
        <MKBox mt={1} mb={3}>
          <MKTypography
            textAlign='justify'
            variant='body2'
            component='p'
            color='light'
          >
            {description}
          </MKTypography>
        </MKBox>
      </MKBox>
    </Card>
  );
}

// Typechecking props for the CenteredBlogCard
CenteredBlogCard.propTypes = {
  color: PropTypes.string,
  image: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  action: PropTypes.shape({
    type: PropTypes.oneOf(['external', 'internal']),
    route: PropTypes.string,
    color: PropTypes.oneOf([
      'primary',
      'secondary',
      'info',
      'success',
      'warning',
      'error',
      'dark',
      'light',
    ]),
    label: PropTypes.string,
  }),
};

export default CenteredBlogCard;
